import { Buffer } from 'buffer';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { applyMediaDevicesPolyfill } from './utils/mediaDevicesPolyfill';
import { initVConsoleIfNeeded } from './utils/vconsoleBootstrap';
import './index.css';
import App from './App';

applyMediaDevicesPolyfill();
initVConsoleIfNeeded();

// 设置全局 Buffer polyfill
if (typeof global === 'undefined') {
  (window as any).global = window;
}

// @ts-ignore
global.Buffer = Buffer;
// @ts-ignore
global.process = global.process || { env: {} };

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Performance monitoring removed - reportWebVitals deleted
